import React from 'react';
import { mdiFootball } from '@mdi/js';
import { BaconTable } from 'common/components/table/bacon';
import { TableTitle } from 'common/components/tables';



export const BetsTable = () => {

  return (
    <>
      <TableTitle icon={mdiFootball} title="Bets" />
      <br />
      <BaconTable
        url={`/bets`}
        defaultQ={'a:id/a:username/f:date_day:-1/f:bookie:ne:molly'}
        currencyColumns={new Set(['Stake', 'Turnover', 'PL'])}
        totalColumns={
          new Set([
            'Stake',
            'Turnover',
            'PL',
            'Stake GBP',
            'Turnover GBP',
            'PL GBP',
            'Stake EUR',
            'Turnover EUR',
            'PL EUR',
          ])
        }
      />
    </>
  );
};
